<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="4"
      cy="10"
      r="1.5"
      fill="currentColor"
    />
    <circle
      cx="10"
      cy="10"
      r="1.5"
      fill="currentColor"
    />
    <circle
      cx="16"
      cy="10"
      r="1.5"
      fill="currentColor"
    />
  </svg>
</template>
